module.exports = __webpack_public_path__ + "static/media/iconphone.b7046ae5.svg";